import React from 'react'

interface ProgressBarProps {
    currentPhase: 1 | 2 | 3
}

const stages = [
    { phase: 1, label: 'Problem statement' },
    { phase: 2, label: 'Coding round' },
    { phase: 3, label: 'Follow-up question' },
] as const

const ProgressBar: React.FC<ProgressBarProps> = ({ currentPhase }) => {
    return (
        <div className="flex flex-col gap-1.5 w-full">
            {/* Progress bar segments */}
            <div className="flex gap-2 w-full">
                {stages.map((stage) => {
                    const isFilled = stage.phase <= currentPhase
                    return (
                        <div
                            key={stage.phase}
                            className={`flex-1 h-2 md:h-1.5 lg:h-2 rounded-md transition-colors duration-300 ${
                                isFilled ? 'bg-green-500' : 'bg-[rgb(202,243,203)]'
                            }`}
                        />
                    )
                })}
            </div>

            {/* Labels row - left aligned with arrow dividers */}
            <div className="flex items-center gap-1.5 text-xs md:text-[10px] lg:text-xs">
                {stages.map((stage, index) => {
                    const isActive = stage.phase === currentPhase
                    return (
                        <React.Fragment key={stage.phase}>
                            <span
                                className={`font-medium transition-colors duration-300 ${
                                    isActive ? 'text-green-600' : 'text-gray-400'
                                }`}
                            >
                                {stage.label}
                            </span>
                            {index < stages.length - 1 && (
                                <span className="text-gray-300">&gt;</span>
                            )}
                        </React.Fragment>
                    )
                })}
            </div>
        </div>
    )
}

export default ProgressBar
